/* ImageUploadBtn.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _5 = "._1bsbqxjr{width:415px}";
const _4 = "._1bsbvbgk{width:4pc}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button';
import { ErrorMessage, HelperMessage } from '@atlaskit/form';
import UploadIcon from '@atlaskit/icon/glyph/upload';
import { Box, Flex } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import React, { useRef } from 'react';
import { isValidHttpUrl } from './ImageField.utils';
import { IMAGE_FIELD_UPLOAD_BUTTON, IMAGE_FIELD_UPLOAD_BUTTON_FILE_INPUT, IMAGE_FIELD_UPLOAD_BUTTON_IMAGE_DISPLAY, IMAGE_FIELD_UPLOAD_BUTTON_SPINNER } from './testIds';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _3 = "._5ral1dfr{object-fit:cover}";
const _2 = "._4t3i1wug{height:auto}";
const _ = "._1bsb1osq{width:100%}";
const Image = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq _4t3i1wug _5ral1dfr", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Image.displayName = 'Image';
}
const smallImage = null;
const mediumImage = null;
const imageFieldDefaultCta = 'Select File';
const ImageUploadBtn = props => {
  const {
    label,
    name,
    url,
    ctaText = {
      upload: imageFieldDefaultCta,
      change: imageFieldDefaultCta
    },
    helperMessage,
    imageUploading,
    errorMessage,
    handleFileChange,
    imageSize = 'small'
  } = props;
  const inputRef = useRef(null);
  return /*#__PURE__*/_jsxs(Box, {
    children: [/*#__PURE__*/_jsx("input", {
      type: "file",
      hidden: true,
      onChange: event => {
        handleFileChange(event.target.files);
      },
      "data-testid": IMAGE_FIELD_UPLOAD_BUTTON_FILE_INPUT,
      ref: inputRef
    }), /*#__PURE__*/_jsxs(Flex, {
      gap: "space.200",
      alignItems: "center",
      children: [imageUploading && /*#__PURE__*/_jsx(Spinner, {
        interactionName: "load",
        label: "Loading",
        size: "medium",
        testId: IMAGE_FIELD_UPLOAD_BUTTON_SPINNER
      }), !imageUploading && isValidHttpUrl(url === null || url === void 0 ? void 0 : url.imageUrl) && /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_4, _5]
        }), /*#__PURE__*/_jsx(Image, {
          src: url === null || url === void 0 ? void 0 : url.imageUrl,
          alt: label || name,
          "data-testid": IMAGE_FIELD_UPLOAD_BUTTON_IMAGE_DISPLAY,
          className: ax([imageSize === 'small' && "_1bsbvbgk", imageSize === 'medium' && "_1bsbqxjr"])
        })]
      }), /*#__PURE__*/_jsx(Button, {
        iconBefore: /*#__PURE__*/_jsx(UploadIcon, {
          label: "upload",
          size: "medium"
        }),
        onClick: () => {
          var _inputRef$current;
          return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.click();
        },
        isDisabled: props.isDisabled || (imageUploading !== null && imageUploading !== void 0 ? imageUploading : false),
        testId: IMAGE_FIELD_UPLOAD_BUTTON,
        children: isValidHttpUrl(url === null || url === void 0 ? void 0 : url.imageUrl) ? ctaText === null || ctaText === void 0 ? void 0 : ctaText.change : ctaText === null || ctaText === void 0 ? void 0 : ctaText.upload
      })]
    }), errorMessage && /*#__PURE__*/_jsx(ErrorMessage, {
      children: errorMessage
    }), helperMessage && /*#__PURE__*/_jsx(HelperMessage, {
      children: helperMessage
    })]
  });
};
export default ImageUploadBtn;